import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import { memo } from 'react';
import css from './Button.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";

var Button = function Button(props) {
  var _ref;

  var big = props.big,
      bordered = props.bordered,
      borderedHover = props.borderedHover,
      borderedInverseHover = props.borderedInverseHover,
      buttonIsh = props.buttonIsh,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      full = props.full,
      gray = props.gray,
      on = props.on,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      linkStyle = props.linkStyle,
      medium = props.medium,
      small = props.small,
      type = props.type,
      white = props.white;
  var attrs = Object.keys(Button.defaultProps);

  var buttonProps = _objectSpread({}, props);

  var moduleClass = cc([css.root, className, (_ref = {}, _defineProperty(_ref, css.big, big), _defineProperty(_ref, css.bordered, bordered), _defineProperty(_ref, css.borderedHover, borderedHover), _defineProperty(_ref, css.borderedInverseHover, borderedInverseHover), _defineProperty(_ref, css.buttonIsh, buttonIsh), _defineProperty(_ref, css.disabled, disabled), _defineProperty(_ref, css.full, full), _defineProperty(_ref, css.gray, gray), _defineProperty(_ref, css.iconLeft, iconLeft), _defineProperty(_ref, css.iconRight, iconRight), _defineProperty(_ref, css.linkStyle, linkStyle), _defineProperty(_ref, css.medium, medium), _defineProperty(_ref, css.small, small), _defineProperty(_ref, css.on, on), _defineProperty(_ref, css.white, white), _ref)]);
  attrs.forEach(function (attr) {
    delete buttonProps[attr];
  }); // if (buttonProps.tabIndex && parseInt(buttonProps.tabIndex, 10) !== -1) {
  //   delete buttonProps['tabIndex'];
  // }

  if (buttonIsh) {
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      className: moduleClass,
      disabled: disabled
    }, buttonProps), {}, {
      children: [iconLeft && iconLeft, children, iconRight && iconRight]
    }));
  }

  if (disabled) {
    buttonProps['aria-disabled'] = disabled;
  }
  /* eslint-disable react/button-has-type */


  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    className: moduleClass,
    disabled: disabled,
    type: type
  }, buttonProps), {}, {
    children: [iconLeft && iconLeft, children, iconRight && iconRight]
  }));
};

Button.defaultProps = {
  big: false,
  bordered: false,
  borderedHover: false,
  borderedInverseHover: false,
  buttonIsh: false,
  className: '',
  disabled: false,
  full: false,
  gray: false,
  on: false,
  iconLeft: false,
  iconRight: false,
  linkStyle: false,
  medium: false,
  small: false,
  type: 'button',
  white: false
};
Button.propTypes = {
  big: PropTypes.bool,
  bordered: PropTypes.bool,
  borderedHover: PropTypes.bool,
  borderedInverseHover: PropTypes.bool,
  buttonIsh: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  full: PropTypes.bool,
  gray: PropTypes.bool,
  iconLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]),
  iconRight: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]),
  linkStyle: PropTypes.bool,
  medium: PropTypes.bool,
  on: PropTypes.bool,
  small: PropTypes.bool,
  type: PropTypes.string,
  white: PropTypes.bool
};
export default /*#__PURE__*/memo(Button);